import React from 'react'
import { TextInput, type TextInputProps } from '@mantine/core'

export type AppInputProps = TextInputProps;

/**
 * Standard text input with consistent sizing and padding.
 * Default size: sm (36px height, compact padding), override with: xs=24px, sm=36px, md=42px, lg=50px
 */
export default function AppInput ({ size = 'sm', ...props }: AppInputProps) {
  return <TextInput radius="sm" size={size} {...props} />
}
